import { useCallback } from 'react';

import { Button } from '@/components/form/baseInputs/Button';
import { useHouseholdChatContext } from '@/modules/household/chat/contexts/householdChat.context';

export interface UseLuminaryAiAssistantAnnouncementProps {
  onClose: () => void;
}

export function useLuminaryAiAssistantAnnouncement({
  onClose,
}: UseLuminaryAiAssistantAnnouncementProps) {
  const { openChat } = useHouseholdChatContext();

  const handleLearnMore = useCallback(() => {
    window.open(
      'https://academy.withluminary.com/articles/2276594182',
      '_blank'
    );
  }, []);

  const handleTryItOut = useCallback(() => {
    onClose();
    openChat();
  }, [onClose, openChat]);

  return {
    heading: 'Introducing Luminary AI Assistant',
    imageUrl: 'luminary-ai-assistant-announcement.png',
    imageAlt: 'Luminary AI Assistant',
    bodyText:
      "Ask questions across all of a household's documents and data, understand how an estate waterfall flows and how taxes are calculated, and get help navigating the platform.",
    actionButtons: (
      <>
        <Button variant="secondary" size="sm" onClick={handleLearnMore}>
          Learn more
        </Button>
        <Button variant="primary" size="sm" onClick={handleTryItOut}>
          Try it out
        </Button>
      </>
    ),
  };
}
